"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _wouter = require("wouter");
var _Style = require("../../style/Style");
var _util = require("../../util");
var _common = require("../../store/common");
var _user = require("../../store/user");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const App = () => {
  const {
    setIsLoading
  } = (0, _common.useCommonStore)();
  const {
    logout
  } = (0, _user.useUserStore)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
    container: true,
    direction: "column",
    spacing: 3,
    sx: {
      justifyContent: 'flex-start'
    },
    ...stylex.props(_Style.wrapper.stretch, _Style.wrapper.sidebarInner),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      ...stylex.props(_Style.textStyle.h1, _Style.textStyle.center),
      children: "LMS\u7BA1\u7406\u753B\u9762"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Grid2, {
      container: true,
      direction: "column",
      spacing: 2,
      ...stylex.props(_Style.textStyle.p1b),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Link, {
        href: "/course",
        ...stylex.props(_Style.textStyle.clearLinkDecoration),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props((0, _util.isCurrentUrl)('/admin/course') || (0, _util.isCurrentUrl)('/admin', true) ? _Style.menuItemStyle.active : _Style.menuItemStyle.inactive),
          children: "\u30B3\u30FC\u30B9\u7BA1\u7406"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Link, {
        href: "/companies",
        ...stylex.props(_Style.textStyle.clearLinkDecoration),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props((0, _util.isCurrentUrl)('/admin/companies') ? _Style.menuItemStyle.active : _Style.menuItemStyle.inactive),
          children: "\u4F01\u696D\u7BA1\u7406"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_wouter.Link, {
        href: "/admin",
        ...stylex.props(_Style.textStyle.clearLinkDecoration),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props((0, _util.isCurrentUrl)('/admin/admin') ? _Style.menuItemStyle.active : _Style.menuItemStyle.inactive),
          children: "\u7BA1\u7406\u8005\u7BA1\u7406"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ...stylex.props(_Style.textStyle.clearLinkDecoration),
        onClick: async () => {
          if (!window.confirm('ログアウトしてよろしいでしょうか？')) return;
          setIsLoading(true);
          await logout();
          setIsLoading(false);
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          ...stylex.props(_Style.menuItemStyle.inactive),
          children: "\u30ED\u30B0\u30A2\u30A6\u30C8"
        })
      })]
    })]
  });
};
var _default = exports.default = App;